import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getAccountsPayableRequest: null,
  getAccountsPayableSuccess: ['accounts'],
  getAccountsPayableFailure: ['error'],
  addAccountPayableRequest: ['account', 'closeModal'],
  addAccountPayableSuccess: ['account'],
  addAccountPayableFailure: ['error'],
  updateAccountPayableRequest: ['account', 'closeModal'],
  updateAccountPayableSuccess: ['account'],
  updateAccountPayableFailure: ['error'],
  removeAccountPayableRequest: ['id'],
  removeAccountPayableSuccess: ['id'],
  removeAccountPayableFailure: ['error'],
  openModal: null,
  closeModal: null,
  setAccountPayableActive: ['account'],
});

export const AccountsPayableTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  accounts: [],
  accountActive: null,
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getAccountsPayableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getAccountsPayableSuccess = (state, { accounts }) =>
  state.merge({
    accounts,
    isLoading: false,
    error: null,
  });

const getAccountsPayableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addAccountPayableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addAccountPayableSuccess = (state, { account }) =>
  state.merge({
    accounts: [...state.accounts, account],
    isLoading: false,
    error: null,
  });

const addAccountPayableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateAccountPayableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateAccountPayableSuccess = (state, { account }) =>
  state.merge({
    accounts: state.accounts.map((item) =>
      item.id === account.id ? account : item
    ),
    isLoading: false,
    error: null,
  });

const updateAccountPayableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeAccountPayableRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeAccountPayableSuccess = (state, { id }) =>
  state.merge({
    accounts: state.accounts.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeAccountPayableFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModal = (state) =>
  state.merge({
    openModal: true,
  });

const closeModal = (state) =>
  state.merge({
    openModal: false,
    accountActive: null,
  });

const setAccountPayableActive = (state, { account }) =>
  state.merge({
    accountActive: account,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ACCOUNTS_PAYABLE_REQUEST]: getAccountsPayableRequest,
  [Types.GET_ACCOUNTS_PAYABLE_SUCCESS]: getAccountsPayableSuccess,
  [Types.GET_ACCOUNTS_PAYABLE_FAILURE]: getAccountsPayableFailure,
  [Types.ADD_ACCOUNT_PAYABLE_REQUEST]: addAccountPayableRequest,
  [Types.ADD_ACCOUNT_PAYABLE_SUCCESS]: addAccountPayableSuccess,
  [Types.ADD_ACCOUNT_PAYABLE_FAILURE]: addAccountPayableFailure,
  [Types.UPDATE_ACCOUNT_PAYABLE_REQUEST]: updateAccountPayableRequest,
  [Types.UPDATE_ACCOUNT_PAYABLE_SUCCESS]: updateAccountPayableSuccess,
  [Types.UPDATE_ACCOUNT_PAYABLE_FAILURE]: updateAccountPayableFailure,
  [Types.REMOVE_ACCOUNT_PAYABLE_REQUEST]: removeAccountPayableRequest,
  [Types.REMOVE_ACCOUNT_PAYABLE_SUCCESS]: removeAccountPayableSuccess,
  [Types.REMOVE_ACCOUNT_PAYABLE_FAILURE]: removeAccountPayableFailure,
  [Types.OPEN_MODAL]: openModal,
  [Types.CLOSE_MODAL]: closeModal,
  [Types.SET_ACCOUNT_PAYABLE_ACTIVE]: setAccountPayableActive,
});

